/**
 * DeferredMedia web component — triggers template content load on click.
 * Mirrors Dawn's DeferredMedia pattern so sleepdoctor-course.css and
 * component-deferred-media.css [loaded] selectors work as expected.
 */
class DeferredMedia extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => this.loadContent(), { once: true });
  }

  loadContent() {
    if (this.hasAttribute('loaded')) return;

    const template = this.querySelector('template');
    if (!template) return;

    const clone = template.content.firstElementChild?.cloneNode(true);
    if (clone) this.appendChild(clone);

    this.setAttribute('loaded', '');

    const media = this.querySelector('video, iframe');
    if (!media) return;

    if (media.tagName === 'VIDEO' && media.hasAttribute('autoplay')) {
      media.play();
    } else if (media.tagName === 'IFRAME' && media.classList.contains('js-youtube')) {
      // Mirror the old theme: drive playback through the YouTube IFrame API so the
      // video starts automatically once the poster is hidden (URL-level autoplay
      // is blocked for dynamically inserted iframes). The iframe src carries
      // enablejsapi=1; the API script is loaded by sections/course.liquid.
      const initPlayer = () => {
        if (window.YT && window.YT.Player) {
          new window.YT.Player(media.id, {
            events: { onReady: (event) => event.target.playVideo() },
          });
        } else {
          setTimeout(initPlayer, 200);
        }
      };
      initPlayer();
    }
    media.focus();
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}
